import React from 'react';
export function Pricing() {
  return <section id="comprar" className="py-16 bg-orange-50" data-id="element-147">
      <div className="container mx-auto px-4" data-id="element-148">
        <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-xl overflow-hidden" data-id="element-149">
          <div className="p-8 md:p-12" data-id="element-150">
            <div className="text-center mb-8" data-id="element-151">
              <div className="bg-orange-600 text-white py-3 px-6 rounded-lg inline-block mb-4 transform -rotate-2 shadow-lg" data-id="element-152">
                <h2 className="text-3xl md:text-4xl font-bold" data-id="element-153">
                  Oferta Especial de Lanzamiento
                </h2>
              </div>
              <p className="text-xl text-gray-600" data-id="element-154">
                Comienza esta misma semana a transformar la forma en que tu
                familia vive el bilingüismo
              </p>
            </div>
            <div className="flex flex-col md:flex-row gap-8 mb-8" data-id="element-155">
              <div className="md:w-1/2" data-id="element-156">
                <div className="bg-orange-100 p-6 rounded-lg" data-id="element-157">
                  <h3 className="text-xl font-semibold text-gray-800 mb-4" data-id="element-158">
                    Lo que obtienes:
                  </h3>
                  <ul className="space-y-3" data-id="element-159">
                    <li className="flex items-start" data-id="element-160">
                      <svg className="h-6 w-6 text-green-500 mr-2 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-161">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-162" />
                      </svg>
                      <span data-id="element-163">
                        <span className="font-medium" data-id="element-164">
                          Guía de Crianza Bilingüe
                        </span>{' '}
                        - El método completo
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-165">
                      <svg className="h-6 w-6 text-green-500 mr-2 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-166">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-167" />
                      </svg>
                      <span data-id="element-168">
                        <span className="font-medium" data-id="element-169">Mini Guía:</span> Cómo
                        Manejar las Pantallas sin Perder el Español
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-170">
                      <svg className="h-6 w-6 text-green-500 mr-2 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-171">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-172" />
                      </svg>
                      <span data-id="element-173">
                        <span className="font-medium" data-id="element-174">Recetas y Palabras:</span>{' '}
                        Cocina con tus Hijos en Español
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-175">
                      <svg className="h-6 w-6 text-green-500 mr-2 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-176">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-177" />
                      </svg>
                      <span data-id="element-178">
                        <span className="font-medium" data-id="element-179">
                          Cuentos Cortos Bilingües
                        </span>{' '}
                        para Dormir
                      </span>
                    </li>
                  </ul>
                  <div className="mt-6 pt-6 border-t border-orange-200" data-id="element-180">
                    <ul className="space-y-4" data-id="element-181">
                      <li className="flex items-center" data-id="element-182">
                        <div className="bg-orange-100 p-2 rounded-full mr-3" data-id="element-183">
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-orange-600" viewBox="0 0 20 20" fill="currentColor" data-id="element-184">
                            <path fillRule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clipRule="evenodd" data-id="element-185" />
                          </svg>
                        </div>
                        <span className="text-gray-700" data-id="element-186">
                          Descarga instantánea
                        </span>
                      </li>
                      
                      <li className="flex items-center" data-id="element-187">
                        <div className="bg-orange-100 p-2 rounded-full mr-3" data-id="element-188">
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-orange-600" viewBox="0 0 20 20" fill="currentColor" data-id="element-189">
                            <path d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" data-id="element-190" />
                          </svg>
                        </div>
                        <span className="text-gray-700" data-id="element-191">
                          Acceso desde cualquier dispositivo
                        </span>
                      </li>
                      <li className="flex items-center" data-id="element-192">
                        <div className="bg-orange-100 p-2 rounded-full mr-3" data-id="element-193">
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-orange-600" viewBox="0 0 20 20" fill="currentColor" data-id="element-194">
                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" data-id="element-195" />
                          </svg>
                        </div>
                        <span className="text-gray-700 font-medium" data-id="element-196">
                          ¡Oferta por tiempo limitado! Después de 200 copias
                          vendidas, el precio volverá a $47 USD
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="md:w-1/2 flex flex-col justify-center" data-id="element-197">
                <div className="text-center" data-id="element-198">
                  <div className="mb-4" data-id="element-199">
                    <span className="text-gray-500 line-through text-xl" data-id="element-200">
                      $29.99 USD
                    </span>
                    <span className="ml-2 bg-orange-100 text-orange-800 px-2 py-1 rounded-md text-sm font-medium" data-id="element-201">
                      67% DESCUENTO
                    </span>
                  </div>
                  <div className="text-4xl font-bold text-orange-600 mb-6" data-id="element-202">
                    $9.99 USD
                  </div>
                  <a href="https://combogourmet.store/cart/50349809402146:1" className="block w-full bg-orange-600 text-white py-4 px-6 rounded-md text-xl font-medium hover:bg-orange-700 transition-colors shadow-md" data-id="element-203">
                    Descargar Ahora
                  </a>
                  <p className="mt-4 text-gray-600 text-sm" data-id="element-204">
                    Pago único. Sin suscripciones. Satisfacción garantizada.
                  </p>
                </div>
              </div>
            </div>
            <div className="text-center" data-id="element-205">
              <p className="text-gray-700 font-medium" data-id="element-206">
                No permitas que el español se pierda en la próxima generación.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}